import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import { Provider } from "react-redux";
import { Router } from "react-router";
import { HashRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.less";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ConfigProvider } from "antd";
import ptPT from "antd/es/locale/pt_PT";
import { BASE_NAME } from "./constants/enviroment";

// Create browser history to use in the Redux store
export const history = createBrowserHistory({ basename: BASE_NAME });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById("root");

ReactDOM.render(
    <Provider store={store}>
        {/* <App /> */}
        {/* TODO: Add react-router-redux */}
        {/* <Router history={history}> */}
        <HashRouter basename={BASE_NAME}>
            <ConfigProvider locale={ptPT}>
                <App />
            </ConfigProvider>
        </HashRouter>
        {/* </Router> */}
    </Provider>,
    rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
